import keys from '@debbie/common/dist/cache/keys.js';
import { addressToString } from '@debbie/common/dist/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { notification } from '@debbie/cortex/dist/notifications.js';
import q from '@debbie/cortex/dist/query.js';
import { tribunalJobsEntity } from '@debbie/cortex/dist/tribunal/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../../../theme.js';
import Checkbox from '../../../Checkbox.js';
import DateInput from '../../../DateInput.js';
import { Edit } from '../../../Icons/index.js';
import Input from '../../../Input.js';
import Money from '../../../Money.js';
import Table from '../../../Table.js';
const DistraintJob = (props) => {
    const { data } = props.job;
    const lang = useSelector((s) => s.lang);
    const [changeDate, setChangeDate] = useState(false);
    const [changeReferenceId, setChangeReferenceId] = useState(false);
    const [changeDateOfCancellation, setChangeDateOfCancellation] = useState(false);
    const [referenceId, setReferenceId] = useState(data.distraint.referenceId || null);
    const updateDistraint = useMutation((data, onDone) => tribunalAPI.patchJob(props.job.id, {
        data,
    }), {
        onSuccess: () => {
            q.invalidate(keys.write.modify(tribunalJobsEntity, props.job.id));
            notification({
                title: lang.tribunal.distraintUpdated,
            });
        },
        onError: (error) => {
            alert('Der skete en fejl');
            console.error(error);
        },
        onSettled: (data, onDone) => onDone?.(),
    });
    return (React.createElement("div", null,
        React.createElement(Table, { zebra: true },
            React.createElement("tr", null,
                React.createElement("td", { style: { width: '30%' } }, lang.tribunal.distraintType),
                React.createElement("td", null,
                    React.createElement("b", null, lang.distraintType[data.distraintType]))),
            React.createElement("tr", null,
                React.createElement("td", { style: { width: '30%' } }, lang.tribunal.amount),
                React.createElement("td", null,
                    React.createElement("b", null, data.distraint.amount ? (React.createElement(Money, { amount: data.distraint.amount })) : ('-')))),
            React.createElement("tr", null,
                React.createElement("td", { style: { width: '30%' } }, lang.tribunal.comment),
                React.createElement("td", null,
                    React.createElement("b", null, data.distraint.comment))),
            data.distraint.address && (React.createElement("tr", null,
                React.createElement("td", { style: { width: '30%' } }, lang.tribunal.address),
                React.createElement("td", null,
                    React.createElement("b", null, addressToString(data.distraint.address))))),
            data.distraint.licenseplate && (React.createElement("tr", null,
                React.createElement("td", { style: { width: '30%' } }, lang.tribunal.licenseplate),
                React.createElement("td", null,
                    React.createElement("b", null, data.distraint.licenseplate)))),
            data.distraint.VIN && (React.createElement("tr", null,
                React.createElement("td", { style: { width: '30%' } }, lang.tribunal.vin),
                React.createElement("td", null,
                    React.createElement("b", null, data.distraint.VIN)))),
            React.createElement("tr", null,
                React.createElement("td", { style: { width: '30%' } }, lang.tribunal.distraintDate),
                React.createElement("td", null,
                    React.createElement("div", { style: { display: 'inline-flex' } },
                        changeDate ? (React.createElement(DateInput, { value: data.distraint.date ? moment(data.distraint.date) : null, allowNull: true, style: { marginBottom: '0px' }, placeholder: lang.tribunal.distraintDate, onChange: (date) => {
                                updateDistraint.mutate({
                                    ...data,
                                    distraint: {
                                        ...data.distraint,
                                        date: date?.format() || null,
                                    },
                                }, () => setChangeDate(false));
                            } })) : (data.distraint.date && (React.createElement("b", null, moment(data.distraint.date).format(THEME.DATE_FORMAT)))),
                        React.createElement(Edit, { style: {
                                cursor: 'pointer',
                                alignSelf: 'center',
                                marginLeft: changeDate || data.distraint.date ? '10px' : '0px',
                            }, onClick: () => setChangeDate(!changeDate) })))),
            React.createElement("tr", null,
                React.createElement("td", { style: { width: '30%' } }, lang.tribunal.distraintReferenceId),
                React.createElement("td", null,
                    React.createElement("div", { style: { display: 'inline-flex' } },
                        changeReferenceId ? (React.createElement(Input, { value: referenceId || undefined, style: { marginBottom: '0px' }, placeholder: lang.tribunal.distraintReferenceId, onChange: (e) => setReferenceId(e.target.value), button: {
                                value: lang.misc.save,
                                loading: updateDistraint.isLoading,
                                onClick: () => {
                                    updateDistraint.mutate({
                                        ...data,
                                        distraint: {
                                            ...data.distraint,
                                            referenceId,
                                        },
                                    }, () => setChangeReferenceId(false));
                                },
                            } })) : (data.distraint.referenceId && (React.createElement("b", null, data.distraint.referenceId))),
                        React.createElement(Edit, { style: {
                                cursor: 'pointer',
                                alignSelf: 'center',
                                marginLeft: changeReferenceId || data.distraint.referenceId
                                    ? '10px'
                                    : '0px',
                            }, onClick: () => setChangeReferenceId(!changeReferenceId) })))),
            React.createElement("tr", null,
                React.createElement("td", { style: { width: '30%' } }, lang.tribunal.distraintCancelled),
                React.createElement("td", null,
                    React.createElement("div", { style: { display: 'inline-flex' } },
                        React.createElement(Checkbox, { checked: data.distraint.cancelled, style: { marginBottom: '0px' }, loading: updateDistraint.isLoading, disabled: updateDistraint.isLoading, onChange: (e) => {
                                updateDistraint.mutate({
                                    ...data,
                                    distraint: {
                                        ...data.distraint,
                                        cancelled: e.target.checked,
                                    },
                                });
                            } })))),
            data.distraint.cancelled && (React.createElement("tr", null,
                React.createElement("td", { style: { width: '30%' } }, lang.tribunal.distraintCancelledDate),
                React.createElement("td", null,
                    React.createElement("div", { style: { display: 'inline-flex' } },
                        changeDateOfCancellation ? (React.createElement(DateInput, { value: data.distraint.dateOfCancellation
                                ? moment(data.distraint.dateOfCancellation)
                                : null, allowNull: true, style: { marginBottom: '0px' }, placeholder: lang.tribunal.distraintCancelledDate, onChange: (date) => {
                                updateDistraint.mutate({
                                    ...data,
                                    distraint: {
                                        ...data.distraint,
                                        dateOfCancellation: date?.format() || null,
                                    },
                                }, () => setChangeDateOfCancellation(false));
                            } })) : (data.distraint.dateOfCancellation && (React.createElement("b", null, moment(data.distraint.dateOfCancellation).format(THEME.DATE_FORMAT)))),
                        React.createElement(Edit, { style: {
                                cursor: 'pointer',
                                alignSelf: 'center',
                                marginLeft: changeDateOfCancellation ||
                                    data.distraint.dateOfCancellation
                                    ? '10px'
                                    : '0px',
                            }, onClick: () => setChangeDateOfCancellation(!changeDateOfCancellation) }))))))));
};
export default DistraintJob;
//# sourceMappingURL=Distraint.js.map